<template>
  <div class="chart-wrapper-box">
    <h1 class="chart-top-title">药品流向top10管理<span @click="openMoadel" class="chart-modal-flag"><i class="el-icon-view"></i></span>
      <div class="chart-select">抗生素类
        <i class="iconfont icon-left select-icon"></i>
      </div>
    </h1>
    <div
      class="chart-wrapper"
      ref="chart"
      style="height:364px;width:100%"
    ></div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <div class="wrap">
        <div class="map" ref='map' :style="windowHeight"></div>
        <div :class="['map-title',isOverMap ? 'map-title-over' : '']" :style="mapTitlePositon">{{mapName}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { vueBus } from '../../assets/js/common/vueBus'
import Map3D from '../../assets/js/common/map3D.js'

export default {
  props: {
    echartsData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      anima: '',
      zoom: 1.2,
      aspectScale: 0.95,
      dialogVisible: false,
      mask: false,
      name: 'map3d',
      title: '地图-线',
      isOverMap: false,
      mapName: '',
      windowHeight: {
        height: '0px'
      },
      mapTitlePositon: {
        left: '800px',
        top: '600px'
      },
    }
  },
  watch: {
    // anima(val, oldVal) {
    //   val == 'animateStart' && this.animate()
    // }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      this.myChart = this.$echarts.init(this.$refs.chart)
      this.initChart()
      // vueBus.$on('imgOnload', v => {
      //   me.animate()
      // })
    })
  },
  methods: {
    animate() {
      let me = this
      this.TweenMax.to(this, 1.5, { zoom: 1.2, onUpdate: me.updateChart })
    },
    updateChart() {
      this.initChart()
    },
    initChart() {
      let me = this
      var geoCoordMap = {
        上海: [121.4648, 31.2891],
        东莞: [113.8953, 22.901],
        东营: [118.7073, 37.5513],
        中山: [113.4229, 22.478],
        临汾: [111.4783, 36.1615],
        临沂: [118.3118, 35.2936],
        丹东: [124.541, 40.4242],
        丽水: [119.5642, 28.1854],
        乌鲁木齐: [87.9236, 43.5883],
        佛山: [112.8955, 23.1097],
        保定: [115.0488, 39.0948],
        兰州: [103.5901, 36.3043],
        包头: [110.3467, 41.4899],
        北京: [116.4551, 40.2539],
        北海: [109.314, 21.6211],
        南京: [118.8062, 31.9208],
        南宁: [108.479, 23.1152],
        南昌: [116.0046, 28.6633],
        南通: [121.1023, 32.1625],
        厦门: [118.1689, 24.6478],
        台州: [121.1353, 28.6688],
        合肥: [117.29, 32.0581],
        呼和浩特: [111.4124, 40.4901],
        咸阳: [108.4131, 34.8706],
        哈尔滨: [127.9688, 45.368],
        唐山: [118.4766, 39.6826],
        嘉兴: [120.9155, 30.6354],
        大同: [113.7854, 39.8035],
        大连: [122.2229, 39.4409],
        天津: [117.4219, 39.4189],
        太原: [112.3352, 37.9413],
        威海: [121.9482, 37.1393],
        宁波: [121.5967, 29.6466],
        宝鸡: [107.1826, 34.3433],
        宿迁: [118.5535, 33.7775],
        常州: [119.4543, 31.5582],
        广州: [113.5107, 23.2196],
        廊坊: [116.521, 39.0509],
        延安: [109.1052, 36.4252],
        张家口: [115.1477, 40.8527],
        徐州: [117.5208, 34.3268],
        德州: [116.6858, 37.2107],
        惠州: [114.6204, 23.1647],
        成都: [103.9526, 30.7617],
        扬州: [119.4653, 32.8162],
        承德: [117.5757, 41.4075],
        拉萨: [91.1865, 30.1465],
        无锡: [120.3442, 31.5527],
        日照: [119.2786, 35.5023],
        昆明: [102.9199, 25.4663],
        杭州: [119.5313, 29.8773],
        枣庄: [117.323, 34.8926],
        柳州: [109.3799, 24.9774],
        株洲: [113.5327, 27.0319],
        武汉: [114.3896, 30.6628],
        汕头: [117.1692, 23.3405],
        江门: [112.6318, 22.1484],
        沈阳: [123.1238, 42.1216],
        沧州: [116.8286, 38.2104],
        河源: [114.917, 23.9722],
        泉州: [118.3228, 25.1147],
        泰安: [117.0264, 36.0516],
        泰州: [120.0586, 32.5525],
        济南: [117.1582, 36.8701],
        济宁: [116.8286, 35.3375],
        海口: [110.3893, 19.8516],
        淄博: [118.0371, 36.6064],
        淮安: [118.927, 33.4039],
        深圳: [114.5435, 22.5439],
        清远: [112.9175, 24.3292],
        温州: [120.498, 27.8119],
        渭南: [109.7864, 35.0299],
        湖州: [119.8608, 30.7782],
        湘潭: [112.5439, 27.7075],
        滨州: [117.8174, 37.4963],
        潍坊: [119.0918, 36.524],
        烟台: [120.7397, 37.5128],
        玉溪: [101.9312, 23.8898],
        珠海: [113.7305, 22.1155],
        盐城: [120.2234, 33.5577],
        盘锦: [121.9482, 41.0449],
        石家庄: [114.4995, 38.1006],
        福州: [119.4543, 25.9222],
        秦皇岛: [119.2126, 40.0232],
        绍兴: [120.564, 29.7565],
        聊城: [115.9167, 36.4032],
        肇庆: [112.1265, 23.5822],
        舟山: [122.2559, 30.2234],
        苏州: [120.6519, 31.3989],
        莱芜: [117.6526, 36.2714],
        菏泽: [115.6201, 35.2057],
        营口: [122.4316, 40.4297],
        葫芦岛: [120.1575, 40.578],
        衡水: [115.8838, 37.7161],
        衢州: [118.6853, 28.8666],
        西宁: [101.4038, 36.8207],
        西安: [109.1162, 34.2004],
        贵阳: [106.6992, 26.7682],
        连云港: [119.1248, 34.552],
        邢台: [114.8071, 37.2821],
        邯郸: [114.4775, 36.535],
        郑州: [113.4668, 34.6234],
        鄂尔多斯: [108.9734, 39.2487],
        重庆: [107.7539, 30.1904],
        金华: [120.0037, 29.1028],
        铜川: [109.0393, 35.1947],
        银川: [106.3586, 38.1775],
        镇江: [119.4763, 31.9702],
        长春: [125.8154, 44.2584],
        长沙: [113.0823, 28.2568],
        长治: [112.8625, 36.4746],
        阳泉: [113.4778, 38.0951],
        青岛: [120.4651, 36.3373],
        韶关: [113.7964, 24.7028]
      }

      var BJData = [
        [
          {
            name: '北京'
          },
          {
            name: '上海',
            value: 95
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '广州',
            value: 90
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '大连',
            value: 80
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '南宁',
            value: 70
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '南昌',
            value: 60
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '拉萨',
            value: 50
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '长春',
            value: 40
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '包头',
            value: 30
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '重庆',
            value: 20
          }
        ],
        [
          {
            name: '北京'
          },
          {
            name: '常州',
            value: 10
          }
        ]
      ]

      var SHData = [
        [
          {
            name: '上海'
          },
          {
            name: '包头',
            value: 95
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '昆明',
            value: 90
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '广州',
            value: 80
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '郑州',
            value: 70
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '长春',
            value: 60
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '重庆',
            value: 50
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '长沙',
            value: 40
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '北京',
            value: 30
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '丹东',
            value: 20
          }
        ],
        [
          {
            name: '上海'
          },
          {
            name: '大连',
            value: 10
          }
        ]
      ]

      var GZData = [
        [
          {
            name: '广州'
          },
          {
            name: '福州',
            value: 95
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '太原',
            value: 90
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '长春',
            value: 80
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '重庆',
            value: 70
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '西安',
            value: 60
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '成都',
            value: 50
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '常州',
            value: 40
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '北京',
            value: 30
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '北海',
            value: 20
          }
        ],
        [
          {
            name: '广州'
          },
          {
            name: '海口',
            value: 10
          }
        ]
      ]

      var planePath =
        'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z'
      function createArrowPath(width, height, curvature) {
        var ps = [0, height, width / 2, 0, width, height, width / 2, (1 - curvature) * height]
        return [
          'M',
          ps[0],
          ps[1],
          'L',
          ps[2],
          ps[3],
          'L',
          ps[4],
          ps[5],
          'L',
          ps[6],
          ps[7],
          'L',
          ps[0],
          ps[1],
          'Z'
        ].join(' ')
      }
      var arrowPath = 'path://' + createArrowPath(1, 1, 0.382)
      var convertData = function(data) {
        var res = []
        for (var i = 0; i < data.length; i++) {
          var dataItem = data[i]
          var fromCoord = geoCoordMap[dataItem[0].name]
          var toCoord = geoCoordMap[dataItem[1].name]
          if (fromCoord && toCoord) {
            res.push({
              fromName: dataItem[0].name,
              toName: dataItem[1].name,
              coords: [fromCoord, toCoord],
              value: dataItem[1].value
            })
          }
        }
        return res
      }

      var color = ['#a6c84c', '#ffa022', '#46bee9']
      var series = []
      ;[['北京', BJData]].forEach(function(item, i) {
        //console.log(item,i);
        series.push(
          {
            name: item[0] + ' Top10',
            type: 'lines',
            zlevel: 1,
            effect: {
              show: true,
              period: 6,
              trailLength: 0.7,
              color: '#fff',
              symbolSize: 4
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 0,
                curveness: 0.2
              }
            },
            data: convertData(item[1])
          },
          {
            name: item[0] + ' Top10',
            type: 'lines',
            zlevel: 2,
            effect: {
              show: true,
              period: 6,
              trailLength: 0,
              symbol: arrowPath,
              symbolSize: 12,
              opacity: 0.8
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 2,
                type: 'dashed',
                opacity: 1,
                curveness: 0.2
              }
            },
            data: convertData(item[1])
          },
          {
            name: item[0] + ' Top10',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 3,
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: '{b}'
              }
            },
            symbolSize: function(val) {
              return 10
            },
            itemStyle: {
              normal: {
                color: color[i]
              }
            },
            data: item[1].map(function(dataItem) {
              return {
                name: dataItem[1].name,
                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
              }
            })
          }
        )
      })
      var option = {
        // title: {
        //   text: '模拟迁徙',
        //   subtext: '数据纯属虚构',
        //   left: 'center',
        //   textStyle: {
        //     color: '#fff'
        //   }
        // },
        // tooltip: {
        //   trigger: 'item',
        //   formatter: function(params, ticket, callback) {
        //     console.log(params)
        //     if (params.seriesType == 'effectScatter') {
        //       return '线路：' + params.data.name + '' + params.data.value[2]
        //     } else if (params.seriesType == 'lines') {
        //       return params.data.fromName + '>' + params.data.toName + '<br />' + params.data.value
        //     } else {
        //       return params.name
        //     }
        //   }
        // },
        // legend: {
        //   orient: 'vertical',
        //   top: 'bottom',
        //   left: 'right',
        //   data: ['北京 Top10', '上海 Top10', '广州 Top10'],
        //   textStyle: {
        //     color: '#fff'
        //   },
        //   selectedMode: 'multiple'
        // },
        geo: {
          type: 'map',
          map: 'china',
          label: {
            emphasis: {
              show: true,
              color: '#fff'
            }
          },
          roam: true,
          zoom: me.zoom,
          aspectScale: me.aspectScale,
          itemStyle: {
            normal: {
              areaColor: '#08A7DF'
              // borderColor: '#404a59'
            },
            emphasis: {
              areaColor: '#de6f00'
            }
          }
        },
        series: series
      }
      this.myChart.setOption(option)
    },
    openMoadel() {
      this.windowHeight.height = $('body').height() + 'px';
      this.dialogVisible = true;
      // 加载地图数据
      $.getJSON("../../static/mapdata/china.json", (geoData) => {
        // 配置项
        let opt = {
          name: 'map1',
          el: this.$refs.map,// dom
          geoData,
          //debugger: true, 
          area:{
            data:[],
            color:0x052659,
            lineColor:0x1481ba,
            opacity:.5,
          },
          mark:{
            data:[],
            color:0xffffff,
          },
          line:{
            data:[],
            hoverExclusive:false
          },
        }

        // 模拟数据
        geoData.features.forEach((i)=>{
          //点数据
          opt.mark.data.push({name:i.properties.name || '',color:0xcaffff,coord:i.properties.cp,size:Math.random()*0.5});
          //线数据
          opt.line.data.push({
            fromName:i.properties.name || '',
            toName:'北京',
            haloDensity:10,
            hasHalo:true,
            hasHaloAnimate:false,
            spaceHeight:Math.random() * 20,
            color:0x0dbdff,
            haloColor:0x052659,
            haloSize:Math.random() * 10,
            coords:[i.properties.cp,[116.4551,40.2539]],
            value:Math.random()*7
          });
        })

        // 初始化
        let map = new Map3D(opt);
        // 动画视角
        // map.setCameraPosition({x:-2,y:-26,z:30},1000,300);

        // 鼠标单击 重新构造连线数据
        map.addEventListener('mousedown', function (event) {
          let area = event.target;
          if(area.type==='Area'){

            let data=[];
            let color = Math.random() * 0xffffff;
            geoData.features.forEach((i)=>{
              //线数据
              data.push({
                fromName:i.properties.name || '',
                toName:area.name || '',
                haloDensity:10,
                spaceHeight:8,
                haloRunRate:0.05,
                color:color,
                haloSize:Math.random()*10,
                haloColor:0x052659,
                coords:[i.properties.cp,area.userData.cp],
                value:Math.random()*1
              });
            })
            data.push({
              fromName:area.name || '',
              toName:area.name || '',
              haloDensity:10,
              spaceHeight:1,
              haloRunRate:0.5,
              color:color,
              haloSize:12,
              coords:[area.userData.cp,area.userData.cp],
              value:Math.random()*1
            });
            map.initLine({data});
          }
        });

        map.addEventListener('mouseout', (event) => {
          let obj = event.target;
          this.isOverMap = false;
          if(obj.type==='Line'){}
        });

        map.addEventListener('mouseover', (event) => {
          let obj = event.target;
          if(obj.type==='Line') {
            this.mapName = (obj.userData.fromName || '') +'-' + (obj.userData.toName || '');
          } else {
            this.mapName = (obj.userData.name || '') + ':' + (obj.userData.value || '');
          };
          this.isOverMap = true;
          this.mapTitlePositon.left = event.offsetX + 40 + 'px';
          this.mapTitlePositon.top = event.offsetY + 30 + 'px';
        })

        map.addEventListener('resize', function (event) {
          console.log('map resize...');
        });
        // map.addCameraPosition({x:-30,y:15,z:15},1000)
        //map.setPosition({x:-13,y:0,z:35})
      });
    },
  },
  created(){

  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
//@import './../../assets/css/index.sass';
.chart-wrapper-box {
  width: 100%;
  height: 100%;
}
.wrap {
  background-image: url('../../../static/imgs/bg2.jpg');
}

.map {
  width: 100%;
  height: 100%;
}

.map-title {
  border-radius: 5px;
  border: 1px solid #ddd;
  color: #fff;
  background: rgba(0, 0, 0, .4);
  position: absolute;
  // z-index: 222;
  opacity: 0;
  padding: 15px;
  text-align: center;
  transition: all .2s;
  pointer-events: none;
}

.map-title-over {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/chinaMap.vue